import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ReportService } from '@app/_components/report';
import { TagJoinService } from './../../../_helpers/tag-join/tag-join.service';
import { TagService } from '@app/_components/task/tag';
import { AlertService } from '@app/_services';
import { TagAddModalComponent } from '@app/_components/task/tag/tag-add-modal/tag-add-modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {TaskService} from '@app/_components/task';

@Component({
    selector: 'app-tag-dd-select',
    template: `



<form [formGroup]="tagDdSelectForm" class="inputDivrow">
  <div class="inputDiv">
    <mat-form-field class="customwidth">
      <mat-label>{{this.tagLabel}}</mat-label>
      <mat-select placeholder="{{tagLabel}}" formControlName="tagId"  #str (selectionChange)="onTagSelect(str.value)" >
        @for (order of tag; track order; let i = $index) {
          <mat-option [value]="tag[i].tagId">
            {{tag[i].name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <button mat-icon-button type="button" class="add-icon-button" (click)="openTagAddModalDialog()" matTooltip="Add New {{this.tagLabel}}">
      <mat-icon>add_circle</mat-icon>
    </button>
    @if (tagId) {
      <mat-icon class="matIcon" (click)="deleteTagSelection()" matDatepickerToggleIcon>delete</mat-icon>
    }
  </div>
</form>
`,
    styles: [],
    standalone: false
})
export class TagSelectDdComponent implements OnInit, OnChanges
{
	tagAddModalDialogRef: MatDialogRef<TagAddModalComponent>;
	tagDdSelectForm: UntypedFormGroup;
	formLoading = false;
	tag = [];

	tagLabel = '';
	@Output() messageEvent = new EventEmitter<string>();
	@Input() taskId: number;

	@Input() tagId: number;

	@Input() tagSourceId: number;

	@Input() tagSource: any;
  isTagAdded = false;
	// 1-folder
	// 2-context
	// 3-goal
	// 4-tag
	// 5-project
	// 6-project-phase
	// 7-process
	@Input() tagType: number;

	// used to store value of tagId before a delete/replace event
	tagIdOriginal;



	constructor(
		private formBuilder: UntypedFormBuilder,
		private reportService: ReportService,
		private taskService: TaskService,
		private tagJoinService: TagJoinService,
		private tagService: TagService,
		private alertService: AlertService,
		private dialog: MatDialog) { }
	ngOnInit()
	{
		// tslint:disable: triple-equals
		if (this.tagType == 1)
		{
			this.tagLabel = 'Folder';
		}
		if (this.tagType == 2)
		{
			this.tagLabel = 'Context';
		}
		if (this.tagType == 3)
		{
			this.tagLabel = 'Goal';
		}
		if (this.tagType == 4)
		{
			this.tagLabel = 'Tag';
		}
		if (this.tagType == 5)
		{
			this.tagLabel = 'Project';
		}
		if (this.tagType == 6)
		{
			this.tagLabel = 'Phase';
		}
		if (this.tagType == 7)
		{
			this.tagLabel = 'Process';
		}

		this.tagDdSelectForm = this.formBuilder.group({
			tagId: [this.tagId],
			tagSource: [this.tagSource],
			tagSourceId: [this.tagSourceId],
			tagType: [this.tagType]
		});

		this.tagIdOriginal = this.tagId;

		this.findTags();
		this.findTagByType(this.tagType, this.tagSource, this.tagSourceId);
	}

	findTagByType(tagType, tagSource, tagSourceId) {
		this.tagJoinService.getTagByType(tagType, tagSource, tagSourceId )
		.subscribe(
			data =>
			{
				var response = data.data.tagJoin;
				if(response != undefined && response.length > 0) {
					this.tagDdSelectForm.patchValue({ tagId: response[0].tagId });
					this.tagId = response[0].tagId;
				}
				console.log(response);
			},
			err =>
			{
				// console.log('Task-Update FAIL: ' + JSON.stringify(err));
				this.alertService.error(err);
			},
		() => { this.formLoading = false; });
	}

	findTags()
	{
		this.taskService.tagSummaryList(this.tagType).pipe(first()).subscribe(

			data =>
			{
				// console.log('reports are: ' + this.tagType + ' ' + JSON.stringify(data));
				this.tag = data.data.tagSummaryList;
				// console.log('QA: ' + JSON.stringify(this.tag));
			},
			error =>
			{
				console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}


	formUpdate()
	{
		try
		{
			// stop here if form is invalid
			// console.log('Form Submitted: ' + JSON.stringify(this.teamSelectForm.value));
			if (this.tagDdSelectForm.invalid)
			{
				// console.log('Form Invalid: ' + JSON.stringify(this.teamSelectForm.getError));
				return;
			}

			this.formLoading = true;
			this.tagJoinService.addTagJoin(this.tagDdSelectForm.value)
				.subscribe(
					data =>
					{
						// console.log('Task-Update SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(data, true);
						this.tagId = data?.data?.taskTag?.tagId;
						// this.router.navigate(['/task-view', this.form1.value.taskId]);
					},
					err =>
					{
						// console.log('Task-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

    /**
     *
     * method to update parent component
     */


	onTagSelect(value)
	{
		console.log('Tag Fired1 ' + value);
		if (this.tagSourceId == null)
		{
			this.alertService.error('Please enter name first');
		}
		else
		{
			this.formUpdate();
		}
		this.messageEvent.emit(this.tagDdSelectForm.value);
	}

    /**
     *
     * method to update this component from parent
     */
	setTagId(tagId: number)
	{
		console.log('Tag Fired2 ' + tagId);
		this.tagId = tagId;
	}
	openTagAddModalDialog()
	{
		{
			this.tagAddModalDialogRef = this.dialog.open(TagAddModalComponent, {
				hasBackdrop: true
			});
			let instance = this.tagAddModalDialogRef.componentInstance;

			// pass the tagType through from the helper to the popup.
			instance.tagType = this.tagType;
			instance.tagLabel = this.tagLabel;

			this.tagAddModalDialogRef.afterClosed().subscribe(result =>
			{
				// refresh the tag list to include the new addition
				this.findTags();
			});
			instance.newTagAddedEvent.subscribe(
				data => {
					console.log('Dialog output:', data);
					this.tagDdSelectForm.value.tagId = data?.data?.tag?.tagId;
					this.formUpdate();
					this.tagDdSelectForm.controls['tagId'].setValue(data?.data?.tag?.tagId);
					this.messageEvent.emit(data?.data?.tag);
				});
		}
	}
	ngOnChanges()
	{
		// This is called when the parent updates. When the parent first initializes, it is in add state, and we have no taskId.  This sets the taskId when add is successful.
		if (this.tagDdSelectForm !== undefined)
		{
			this.tagDdSelectForm.patchValue({ tagSourceId: this.tagSourceId });

		}
	}

  deleteTagSelection() {
    this.tagJoinService.deleteTagJoin(this.tagDdSelectForm.value).subscribe(
      data =>
      {
		  this.tagId = null;
        this.tagDdSelectForm = this.formBuilder.group({
          tagId: [this.tagId],
          tagSource: [this.tagSource],
          tagSourceId: [this.tagSourceId],
          tagType: [this.tagType]
        });
        this.alertService.success(data, true);
      },
      err =>
      {
        this.alertService.error(err);
      },
      () => { this.formLoading = false; });
  }
}
